export function RecruitmentHubSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/recruitment-hub.svg'"></ng-include>`
    }
}